export default "/images/vendor/flag-icon-css/flags/4x3/ki.svg?de100d3095b62260166f474b5bd7bbb4";